export const boxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 2,
  mt: 2,
  pl: 2,
  flexDirection: 'row',
};
